import { FormFieldTypes } from "../../../../data/formFieldType";

export const BusinessActivityData = {
  name: "BusinessActivity",
  initialState: {
    organisationCategory: null,
    others: "",
    productsandServicesOfferedbyOrganisation: null,
    otherproductsandServices:"",
    typeOfProduct: "",
    annualTurnover: "",
    numberofEmployees: "",
    describeTheWays: "",
    companyDescription: "",
    
  },

  formFields: [
    {
      id: "organisationCategory",
      lable: "Organisation Category",
      Field_Name: "OrganisationCategory",
      fieldType: FormFieldTypes.SELECT,
      dataField: "organisationCategory",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "others",
      lable: "Others",
      Field_Name: "Others",
      fieldType: FormFieldTypes.INPUT,
      dataField: "others",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        isDisable:true
      },
      style: {
        containerCss: "col-md-6 mb-3 mt-auto d-none",
      },
    },
     {
      id: "applicantOrganisationProfile",
      lable: "",
      Field_Name: "",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "applicantOrganisationProfile",
      fieldSetting: {
        formTitle: "",
      },
      style: {
        containerCss: "col-lg-6 mb-2 text-left",
      },
    },
    {
      id: "productsandServicesOfferedbyOrganisation",
      lable: "Products and Services Offered by Organisation",
      Field_Name: "Products and Services Offered by Organisation",
      fieldType: FormFieldTypes.SELECT,
      dataField: "productsandServicesOfferedbyOrganisation",
      fieldSetting: {
        placeholder: "Select",
        isMultiSelect: true,
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
      {
      id: "otherproductsandServices",
      lable: "Other Consultancies; Please specify",
      Field_Name: "Other Consultancies; Please specify",
      fieldType: FormFieldTypes.INPUT,
      dataField: "otherproductsandServices",
      fieldSetting: {
       placeholder: "",
       allowSpace: true,
       isDisable:true
      },
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "",
      lable: "",
      Field_Name: "",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "",
      fieldSetting: {
        formTitle: "",
      },

      style: {
        containerCss: "col-lg-6 mb-3 text-left",
      },
    },
    {
      id: "typeOfProduct",
      lable: "Type of Product(s) or Services(s)",
      Field_Name: "typeOfProduct",
      fieldType: FormFieldTypes.TEXTAREA,
      dataField: "typeOfProduct",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-12 mb-3",
      },
    },
    {
      id: "annualTurnover",
      lable: "Annual Turnover (SGD)",
      Field_Name: "Annual Turnover (SGD)",
      fieldType: FormFieldTypes.SELECT,
      dataField: "annualTurnover",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "numberofEmployees",
      lable: "Number of Employees",
      Field_Name: "Number of Employees",
      fieldType: FormFieldTypes.SELECT,
      dataField: "numberofEmployees",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "describeTheWays",
      lable: "Describe the ways in which your organisation is or will be involved in the green building movement",
      Field_Name: "your organisation’s green building movement involvement",
      fieldType: FormFieldTypes.TEXTAREA,
      dataField: "describeTheWays",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        maxWords:1000
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-12 mb-3",
      },
    },
    {
      id: "companyDescription",
      lable: "Company Description (Note: Information will be displayed in the Members’ Directory)",
      Field_Name: "Company Description (Note: Information will be displayed in the Members’ Directory)",
      fieldType: FormFieldTypes.TEXTAREA,
      dataField: "companyDescription",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        maxWords:500
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-12 mb-3",
      },
    },
  ],

  formSetting: {
    isViewOnly: false,
  },
};